// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-lkmhc{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-xxsnw{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-gztpq{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bqmnu{grid-column:span 3}.assets-scss-gridstyleGrid-col4-ybwtu{grid-column:span 4}.assets-scss-gridstyleGrid-col9-rlqbs{grid-column:span 9}.assets-scss-gridstyleGrid-col12-exryt{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-jamhp{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-lkmhc",
	"grid": "assets-scss-gridstyleGrid-grid-xxsnw",
	"col6": "assets-scss-gridstyleGrid-col6-gztpq",
	"col3": "assets-scss-gridstyleGrid-col3-bqmnu",
	"col4": "assets-scss-gridstyleGrid-col4-ybwtu",
	"col9": "assets-scss-gridstyleGrid-col9-rlqbs",
	"col12": "assets-scss-gridstyleGrid-col12-exryt",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-jamhp"
};
module.exports = ___CSS_LOADER_EXPORT___;
